module.exports = __webpack_public_path__ + "static/img/main_calendar_icon_b.a0650036.svg";